module.exports = "/img/automation/One-icon-default.png?4443a39cc2d69b6257bc8f2e6a1cdbbb";